module.exports = __webpack_public_path__ + "static/media/icon-replace-hover.c20c1b01.svg";